<template>
  <ul>
  <li class="review__item__rating" v-if="isReview" >
    <span class="star-wrap star-size-22"><span :class="averageNumber | formatRatingClassName('star-')">{{ averageNumber | formatRating }}</span></span>
    <span class="rating-num">5つ星のうち<span class="num">{{ averageNumber }}</span></span>
  </li>
  <li class="review__item__rating" v-if="!isReview" ><span class="star0"></span><span class="rating-num">まだ評価はありません</span></li>
  <li class="review__item__count" v-if="isReview" >
    <a :href="itemReviewUrl">
      <span class="count-num"><span class="num">{{ count }}</span>件</span>のレビューを見る
    </a>
  </li>
  <li class="review__item__count" v-if="!isReview" ><a><span class="count-num"><span class="num">0</span>件</span>のレビュー</a></li>
</ul>
</template>

<script>
import urls from '@/mixins/urls'
import errors from '@/mixins/errors'
export default {
  name: 'BaseReviewRatingAverage',
  mixins: [ urls, errors ],
  props: {
    average: {
      type: String,
      default: ''
    },
    count: {
      type: Number,
      default: 0
    },
    skuCode: {
      type: String,
      required: true
    },
    itemName: {
      type: String,
      default: ''
    }
  },
  computed: {
    averageNumber () {
      return Math.round(Number(this.average) * 10) / 10
    },
    itemDetailUrl () {
      return this.getItemDetailUrl(this.skuCode)
    },
    itemImageUrl () {
      return this.getItemImageUrl(this.skuCode)
    },
    itemReviewUrl () {
      return this.getItemReviewUrl(this.skuCode)
    },
    isReview () {
      return !this.isGlobalError && Number(this.count) > 0
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/BaseReviewRatingAverage.vue